import {
  useMutation,
  useQuery,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query';
import { useApiClient } from 'utils/apiClient';
import {
  Account,
  AccountResponseType,
} from 'utils/apiClient/services/shorepay/types';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';

export const useAccount = (
  opts: Omit<
    UseQueryOptions<Account, unknown, Account, string[]>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['shorepay', 'account'],
    queryFn: apiClient.ShorePay.fetchAccount,
    retry: false,
    ...opts,
  });
};

function checkTypeAccountOrError(data: AccountResponseType): data is Account {
  if ((data as Account).account_link) {
    return true;
  }
  return false;
}

export const useCreateAccount = (opts: UseMutationOptions = {}) => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.ShorePay.createAccount,
    onSettled: (data: AccountResponseType, error) => {
      if (error) {
        handleErrorNotification({
          error: (error as Error).message,
          lang: intl.locale.toLowerCase(),
        });
      } else if (checkTypeAccountOrError(data)) {
        if (data.account_link?.url) {
          window.location.replace(data.account_link.url);
        }
      } else {
        handleErrorNotification({
          error: data?.message,
          lang: intl.locale.toLowerCase(),
        });
      }
    },
    ...opts,
  });
};
